"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkipNavigation = SkipNavigation;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _button = _interopRequireDefault(require("@ux/button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const buttonStyles = "pl-b10eefqc";
function SkipNavigation({
  skipToId = 'main-content',
  text,
  _name,
  ...rest
}) {
  const [skipTarget, setSkipTarget] = (0, _react.useState)('#main-content');
  (0, _react.useEffect)(() => {
    if (typeof document !== 'undefined') {
      const focusOn = [`#${skipToId}`, '#main', '#root'].find(sel => document.querySelector(sel));
      if (focusOn) {
        setSkipTarget(focusOn);
      }
    }
  }, [skipToId]);
  return /*#__PURE__*/_react.default.createElement(_button.default, (0, _extends2.default)({
    className: buttonStyles,
    text: text,
    href: skipTarget,
    design: "secondary",
    "data-cy": "skip-navigation"
  }, _patternLibraryUtils.tracking.create(_name, true, false), rest));
}
SkipNavigation.propTypes = {
  skipToId: _propTypes.default.string,
  text: _propTypes.default.string,
  _name: _propTypes.default.string,
  ..._button.default.propTypes
};